export const SHARED_TENANT_PATH = 'shared'
export const READ_ONLY_WORKSPACE = 'read'
export const NO_LAYER_PATH = 'none'
export const DEFAULT_BLOCK = 'production'
